import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import ViolenceRiskList from "./Residential/Optional/ViolenceRisk/ViolenceRiskList";

import {
    fetchViolenceRisks,
    deleteViolenceRisk,
} from "../store/slices/violenceRisksSlice";

const ViolenceRisks = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const {
        violenceRisks,
        isLoading,
    } = useSelector((state) => state.violenceRisks);

    // Fetch data on mount
    useEffect(() => {
        dispatch(fetchViolenceRisks());
    }, [dispatch]);

    const handleAdd = () =>
        navigate("/residential/optional/violence-risk/add");

    const handleEdit = (id) =>
        navigate(`/residential/optional/violence-risk/edit/${id}`);

    const handleDelete = async (id) => {
        await dispatch(deleteViolenceRisk(id));
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body p-0">
                        <ViolenceRiskList
                            records={violenceRisks}
                            loading={isLoading}
                            onAdd={handleAdd}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default ViolenceRisks;
